import script from "./ShowDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowDetails.vue?vue&type=script&setup=true&lang=js"

import "./ShowDetails.vue?vue&type=style&index=0&id=0b12826e&scoped=true&lang=css"

import exportComponent from "E:\\cymcorp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b12826e"]])

export default __exports__